import * as ActionTypes from '../constants/actionTypes'
import { userGetCount, userGetPage } from '../api/user'

export const fetchItems = (params = {}) => (dispatch) => {
  dispatch({ type: ActionTypes.USERLIST_FETCHITEMS_LOAD })

  userGetCount(params).then((res) => {
    const total = parseInt(res.result.n_count)

    userGetPage(params).then((res) => {
      const items = res.result

      const newItems = items

      items.map((obj, key) =>
        newItems[key].n_disable = obj.n_disable === '1')

      dispatch({
        type: ActionTypes.USERLIST_FETCHITEMS_SUCCEED,
        items: newItems,
        total,
      })
    }).catch((err) => {
      dispatch({
        type: ActionTypes.USERLIST_FETCHITEMS_FAIL,
        fetchItemsError: 'Ошибка получения списка пользователей',
      })
    })
  }).catch((err) => {
    dispatch({
      type: ActionTypes.USERLIST_FETCHITEMS_FAIL,
      fetchItemsError: 'Ошибка получения кол-ва пользователей',
    })
  })
}

export const changeTable = params => (dispatch) => {
  const { pagination = {}, filters = {}, sorter = {} } = params
  dispatch({
    type: ActionTypes.USERLIST_CHANGETABLE_CHANGE,
    pagination,
    filters,
    sorter,
  })
}

export const searchTable = ({ isSearching }) => (dispatch) => {
  dispatch({
    type: ActionTypes.USERLIST_SEARCHTABLE_SEARCH,
    isSearching,
  })
}

export const editSearch = params => (dispatch) => {
  const { search } = params
  dispatch({
    type: ActionTypes.USERLIST_SEARCHTABLE_EDIT,
    search,
  })
}




// WEBPACK FOOTER //
// src/actions/userList.js